export enum TopicModerationStatus {
  NEW = 0,
  APPROVED = 1,
  DELAY = 2,
  REJECTED = 3,
  DRAFT = 4,
}
